import React, { useEffect, useState } from "react";

import "./QuantitySelector.scss";

interface QuantitySelectorProps {
	max: number;
	onChange: (quantity: number) => void;
	initValue: number;
	testid?: string;
	inventoryCount?: number;
	showZero?: boolean;
}

const QuantitySelector: React.FC<QuantitySelectorProps> = ({
	max,
	onChange,
	initValue,
	testid,
	inventoryCount = max,
	showZero = true,
}) => {
	const [quantity, setQuantity] = useState(initValue);

	useEffect(() => {
		setQuantity(initValue);
	}, [initValue]);

	const handleIncrease = (e: React.MouseEvent) => {
		e.stopPropagation();
		if (quantity < max) {
			const newQuantity = quantity + 1;

			setQuantity(newQuantity);
			onChange(newQuantity);
		}
	};

	const handleDecrease = (e: React.MouseEvent) => {
		e.stopPropagation();
		if (quantity > 0) {
			const newQuantity = quantity - 1;

			setQuantity(newQuantity);
			onChange(newQuantity);
		}
	};

	if (!showZero && quantity === 0) {
		return (
			<button
				className="QuantitySelector AddToCartBtn"
				onClick={handleIncrease}
				data-testid={testid}
			>
				+
			</button>
		);
	}

	return (
		<div className="QuantitySelector" data-testid={testid}>
			<button className="QuantityButton decrease FadeIn" onClick={handleDecrease}>
				−
			</button>
			<span className="QuantityDisplay FadeIn">{quantity}</span>
			<button className="QuantityButton increase" onClick={handleIncrease}>
				+
			</button>
		</div>
	);
};

export default QuantitySelector;
